export default __webpack_public_path__ + "static/media/sand-bottle-logo.7ddadf72.svg";